module.exports = __webpack_public_path__ + "static/media/update-icon.4d852eef.svg";